import { requestWrapper } from '@/api';
import { nextTick, type Ref } from 'vue';
import type { Pagination, Scroll } from '@/types/option';
import type { QVirtualScroll } from 'quasar';
import type { AddPasswordFormData } from '@/types/request';
import { setPagination } from '@/service/index';
import type { List, ListEntry } from '@/types/list';

export async function Submit(data: AddPasswordFormData) {

  return await requestWrapper.post({
    path: '/user/pass',
    body: data
  });
}

export async function Load(rows: Ref<ListEntry[]>, pagination: Ref<Pagination>, loading: Ref<boolean>, loaded: Ref<boolean>, pageSize: number, count?: boolean, table?: Scroll) {
  const { sortBy, descending } = pagination.value;
  const lastIndex = rows.value.length > 0 ? rows.value.length - 1 : undefined;

  if (loading.value || loaded.value || lastIndex !== table?.to) {
    return;
  }

  loading.value = true;
  await requestWrapper.post({
    path: '/user/pass/list',
    body: {
      lastID: pagination.value.lastId,
      limit: pageSize,
      descending: descending,
      sortBy: sortBy,
      count: count
    }
  }).then(async (response: Response) => {
    setPagination(await response.json() as List, rows, pagination, loaded, count);
  }).finally(() => {
    void nextTick(() => {
      if (table) {
        (table.ref as QVirtualScroll).refresh();
      }
      loading.value = false;
    });
  });
}

export async function Delete(selected: ListEntry[], loading: Ref<boolean>) {
  loading.value = true;
  const ids: string[] = [];
  selected.forEach((value) => {
    ids.push(value.id);
  });
  return requestWrapper.delete({
    path: '/user/pass',
    body: { ids: ids }
  }).then((response: Response) => {
    loading.value = false;
    return response;
  });
}

export const Pass = {
  columns: [
    { name: 'index', label: '#', field: 'index' },
    { name: 'id', label: 'ID', field: 'id' },
    { name: 'name', label: 'Name', field: 'name' },
    { name: 'user', label: 'Username', field: 'user' },
    { name: 'generated', label: 'Generated', field: 'generated' },
    { name: 'comment', label: 'Comment', field: 'comment' },
    { name: 'created_at', label: 'Created at', field: 'created_at' },
    { name: 'updated_at', label: 'Updated at', field: 'updated_at' }
  ],
  visible: ['index', 'name', 'user', 'generated', 'comment', 'created_at', 'updated_at']
};
